<template>
  <!-- <ScreenAdapter> -->
  <div>
    <div id="main">
      <Aside></Aside>
      <Header :hideBg="true" :p_search="true" :content="$route.query.keywords" />
      <div class="eol-main-container">
        <div class="search-box">
          <input type="text" v-focus v-model="keywords">
          <div class="search-btn" @click="getListData()">搜索</div>
        </div>
        <div class="search-keywords">
          <div class="k-inner" v-if="!showResult">
            您还没有进行搜索
          </div>
          <div class="k-inner" v-else>
            您搜索的关键词“{{ searched }}”，共有{{total}}条结果
          </div>

        </div>
        <div class="search-content">
          <div class="item" v-for="(item,index) in listData" :key="index" @click="jumpDetail(item)">
            <div class="c-img" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
          <div class="flex-hide"></div>
          <div class="flex-hide"></div>
          <div class="flex-hide"></div>
        </div>
        <a-pagination v-if="listData&&listData.length>0" :defaultPageSize="size" :default-current="1" :total="total" @change="onChange" />

        <div class="no-search" v-if="!showResult">
          <img src="../../../assets/custom/party/search/no-search.png">
        </div>
      </div>
      <Footer />
    </div>
  </div>
  <!-- </ScreenAdapter> -->

</template>

<script>
import Vue from 'vue'
Vue.directive('focus', { inserted: function (el) { el.focus() } })
import Header from "@/components/Custom/Party/Header.vue"
import Footer from "@/components/Custom/Party/Footer.vue"
import services from "../../../config/services"
import { Message } from "ant-design-vue"
import Aside from '../../../components/Custom/Party/Aside.vue'
// import ScreenAdapter from "@/components/ScreenAdapter"

export default {
  data () {
    let that = this
    return {
      school_code: localStorage.getItem("schoolCode"),
      listData: [], // 弘扬劳动三精神
      keywords: "",
      searched: "",
      keyList: [
        { name: "新思想 新征程", path: `new` },
        { name: "党性教育", path: `edu` },
        { name: "四史领悟", path: `learn` },
        { name: "入党必备", path: `join` },
        { name: "榜样人物", path: `example` },
        { name: "地方特色篇", path: `local`, },
      ],
      page: 1,
      total: 0,
      size: 16,
      showResult: false,
      category_id: "222,211,225,207,230,233"
    }
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  },

  async mounted () {
    // await this.getListData()
  },
  methods: {
    // 请求列表数据
    async getListData () {
      let that = this
      if (!that.keywords.trim()) {
        return Message.error("请输入搜索内容")
      }
      await services.getCourseList({ page: this.page, size: this.size, q: that.keywords, school_code: this.school_code, category_id: this.category_id }).then(res => {
        this.searched = this.keywords
        this.listData = res.data.items
        this.total = res.data.total
        this.showResult = true
      })
    },
    async onChange (val) {
      this.page = val
      await this.getListData()
    },
    jumpDetail (item) {
      let that = this
      let find = false
      that.keyList.forEach(row => {
        if (item.category_name.indexOf(row.name) > -1) {
          find = true
          return window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=${row.path}`, "_blank")
        }
      })
      if (!find) window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}`, "_blank")
    },
  },
}
</script>

<style lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
#main {
    background: #fff;
}
.platform-cover {
    width: 100%;
    height: 660px;
}

.eol-main-container {
    padding: 32px 0 0;

    min-height: 717px;
    .search-box {
        display: flex;
        justify-content: center;
        width: 1200px;
        margin: 0 auto;
        input {
            width: 484px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #d2d2d2;
            color: #333;
            padding: 0 15px;
        }
        .search-btn {
            width: 77px;
            height: 40px;
            background: #b1000e;
            text-align: center;
            line-height: 40px;
            // transition: all 0.7s;
            font-size: 16px;
            color: #fef6c7;
            cursor: pointer;
            &:hover {
                color: #fef6c7;
                background: #99010d;
            }
        }
    }
    .search-keywords {
        font-size: 16px;
        font-weight: bold;
        color: #b1000e;
        word-break: break-all;
        width: 100%;
        height: 58px;
        background: #f8f8f8;
        line-height: 58px;
        margin: 30px 0 27px;
        .k-inner {
            width: 1200px;
            margin: 0 auto;
        }
    }
    .search-content {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 1200px;
        margin: 0 auto;
        .item {
            width: 280px;
            height: 157px;
            overflow: hidden;
            margin-bottom: 24px;
            cursor: pointer;
            &:hover {
                .c-img {
                    transform: scale(1.2);
                }
            }
            .c-img {
                width: 100%;
                height: 100%;
                transition: all 0.7s;
            }
        }
        .flex-hide {
            flex: 0 0 280px;
            visibility: hidden;
            display: block;
        }
    }
}

// ant-page 红色
::v-deep .ant-pagination-item-active {
    border-color: transparent;
    background: #b61e2a;
}
::v-deep .ant-pagination-item:hover {
    border-color: #b61e2a;
}
::v-deep .ant-pagination-item:hover a,
::v-deep .ant-pagination-item a {
    color: #666666;
}
::v-deep .ant-pagination-item-active a,
::v-deep .ant-pagination-item-active:hover a {
    color: #ffffff;
}
::v-deep .ant-pagination-prev:focus .ant-pagination-item-link,
::v-deep .ant-pagination-next:focus .ant-pagination-item-link,
::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: #b61e2a;
}
::v-deep .ant-pagination-prev:focus .ant-pagination-item-link .anticon {
    color: #b61e2a;
}
::v-deep .ant-pagination-next:focus .ant-pagination-item-link .anticon {
    color: #b61e2a;
}
::v-deep .ant-pagination-prev:hover .ant-pagination-item-link .anticon {
    color: #b61e2a;
}
::v-deep .ant-pagination-next:hover .ant-pagination-item-link .anticon {
    color: #b61e2a;
}
::v-deep .ant-pagination {
    text-align: center;
    margin: 30px 0 40px;
}
.no-search {
    display: flex;
    justify-content: center;
    margin-top: 85px;
    img {
        width: 313px;
    }
}
</style>